import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import Landing from './pages/Landing';
import Checkout from './pages/Checkout';
import Confirmation from './pages/Confirmation';
import Offers from './pages/Offers';
import Membership from './pages/Membership';
import MembershipConfirmation from './pages/MembershipConfirmation';
import { initTracking, captureUtms } from './utils/tracking';

function App() {
  useEffect(() => {
    captureUtms();
    initTracking();
    TagManager.initialize({ gtmId: 'GTM-PRWJP9K' });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/confirmation" element={<Confirmation />} />
        <Route path="/offers" element={<Offers />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/membership/confirmation" element={<MembershipConfirmation />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
